import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';
import { applicationReportsValidationSchema } from '~/components/ApplicationReports/validationSchema.ts';
import { TApplicationReportsForm } from '~/components/ApplicationReports/types.ts';
import { initialValuesApplicationReports } from '~/components/ApplicationReports/initialValues.ts';

export const useApplicationReportsForm = () => {
  const resolver: Resolver<TApplicationReportsForm> = yupResolver(
    applicationReportsValidationSchema,
    { abortEarly: false }
  ) as unknown as Resolver<TApplicationReportsForm>;

  const form = useForm<TApplicationReportsForm>({
    defaultValues: cloneDeep(initialValuesApplicationReports),
    resolver,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};
